import {SmtpEmailProviderCode} from '@dms/api/core';
import i18n from '@dms/i18n';

export const providerNamesByCode: Record<SmtpEmailProviderCode, string> = {
  'gmail-smtp': i18n.t('page.integrations.labels.gmail'),
  'outlook-smtp': i18n.t('page.integrations.labels.outlook'),
  'seznam-smtp': i18n.t('page.integrations.labels.seznam'),
  'custom-smtp': i18n.t('page.integrations.labels.customSmtp'),
  'microsoft-oauth': i18n.t('page.integrations.labels.microsoftOauth'),
};
